import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from '../Screens/Login';
import Learner from '../Screens/Learner';
import NoRoute from '../Screens/NoRoute';
import LearnerThinkTool from '../Screens/LearnerThinkTool';


import Content from '../Screens/Content';
import Modules from '../Screens/Modules';
// import Report from '../Screens/Report';
import Assessments from '../Screens/Assessments';
import Versions from '../Screens/Versions';
 

// import asyncComponent from '../asyncComponent';

 import Tools from '../Screens/Tools';
// import LearnerProgrammesList from './LearnerProgrammesList';
 import LearnerProgrammesChoice from './LearnerProgrammesChoice';
import Sessions from '../Screens/Sessions';

// import Assessments from '';


const Routes = () => (
  <Switch>
    {/* <Route path="/tools/:programId/:contentId/:versionId?" component={LearnerThinkTool} />
    <Route path="/team-leader/:userId/:contentId/:versionId" component={TeamLeaderThinkTool} />
    <Route path="/team-leader" component={TeamLeader} /> */}

    <Route path="/tools/:programId/:contentId/:versionId?" component={LearnerThinkTool} exact/>
    <Route path="/home" component={Learner} />
    <Route path="/modules/:programId" component={Modules} exact/>
    <Route path="/content/:programId/:moduleId" component={Content} exact/>
    <Route path="/chooseassessment" component={LearnerProgrammesChoice} />
    <Route path="/assessments/:programId" component={Assessments} exact/>
    <Route path="/choosetool" component={LearnerProgrammesChoice} exact/>
    <Route path="/choosesession" component={LearnerProgrammesChoice} exact/>
    <Route path="/programs" component={LearnerProgrammesChoice} exact />
    <Route path="/tools/:programId" component={Tools} exact/>
    <Route path="/sessions/:programId" component={Sessions} exact/>
    <Route path="/versions/:programId/:moduleId/:contentId" component={Versions} exact/>
    {/* 
   
    

    
  
    <Route path="/assessments" component={Assessments} /> */}
    <Route path="/login" exact component={Login} />
    <Route path="/" exact component={Login} />
    <Route component={NoRoute} />
  </Switch>
);

export default Routes;
